<nav class="stepper" aria-label="Package editor workflow">
  <ol class="stepper__list" role="list">
    @for (step of steps(); track trackById($index, step); let last = $last) {
    <li
      class="stepper__item"
      [class.stepper__item--complete]="step.status === 'complete'"
      [class.stepper__item--in-progress]="step.status === 'in-progress'"
      [class.stepper__item--warning]="step.status === 'warning'"
      [class.stepper__item--error]="step.status === 'error'"
      [class.stepper__item--empty]="step.status === 'empty'"
      [class.stepper__item--active]="activeId() === step.id"
    >
      <button
        type="button"
        class="stepper__step"
        [attr.aria-current]="activeId() === step.id ? 'step' : null"
        [attr.aria-label]="
          'Step ' +
          step.index +
          ': ' +
          step.label +
          ' — status ' +
          step.status
        "
        (click)="selectStep(step.id)"
      >
        <span class="stepper__indicator" aria-hidden="true">
          @switch (step.status) { @case ('complete') {
          <mat-icon class="stepper__indicator-icon">check</mat-icon>
          } @case ('warning') {
          <mat-icon class="stepper__indicator-icon">warning</mat-icon>
          } @case ('error') {
          <mat-icon class="stepper__indicator-icon">close</mat-icon>
          } @case ('in-progress') {
          <span class="stepper__indicator-num">{{ step.index }}</span>
          } @default {
          <span class="stepper__indicator-num">{{ step.index }}</span>
          } } @if (step.dirty) {
          <span
            class="step-dirty-dot"
            data-testid="enrichment-step-dirty-dot"
            title="Unsaved changes"
          ></span>
          }
        </span>

        <span class="stepper__body">
          <span class="stepper__label-row">
            <span class="stepper__label">{{ step.label }}</span>
            @if (step.badge !== undefined && step.badge !== null) {
            <span class="stepper__badge">{{ step.badge }}</span>
            }
          </span>
          @if (step.subLabelTh) {
          <span class="stepper__sub" lang="th">{{ step.subLabelTh }}</span>
          }
        </span>
      </button>

      @if (!last) {
      <span class="stepper__connector" aria-hidden="true"></span>
      }
    </li>
    }
  </ol>

  @if (advancedSteps().length > 0) {
  <div class="stepper__advanced">
    <button
      type="button"
      class="stepper__advanced-trigger"
      [class.stepper__advanced-trigger--open]="dropdownOpen()"
      [class.stepper__advanced-trigger--active]="activeIsAdvanced()"
      [attr.aria-haspopup]="'menu'"
      [attr.aria-expanded]="dropdownOpen()"
      (click)="toggleDropdown()"
    >
      <span>{{ advancedTriggerLabel() }}</span>
      <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
        [class.stepper__advanced-chev--open]="dropdownOpen()"
      >
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </button>

    @if (dropdownOpen()) {
    <ul class="stepper__advanced-menu" role="menu">
      @for (step of advancedSteps(); track trackById($index, step)) {
      <li role="none">
        <button
          type="button"
          role="menuitem"
          class="stepper__advanced-item"
          [class.stepper__advanced-item--active]="activeId() === step.id"
          (click)="selectAdvanced(step.id)"
        >
          <span class="stepper__advanced-label">{{ step.label }}</span>
          @if (step.subLabelTh) {
          <span class="stepper__advanced-sub" lang="th">
            {{ step.subLabelTh }}
          </span>
          }
        </button>
      </li>
      }
    </ul>
    }
  </div>
  }
</nav>
